import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'

import PDSButton from 'designSystem/components/PDSButton/PDSButton'
import PDSFlexBox from 'designSystem/components/PDSFlexBox/PDSFlexBox'
import PDSSeparator from 'designSystem/components/PDSSeparator/PDSSeparator'
import PDSText from 'designSystem/components/PDSText/PDSText'
import { COLOR } from 'designSystem/foundations/constants/color'
import { FONT_WEIGHT } from 'designSystem/foundations/constants/fontWeight'
import { SIZE } from 'designSystem/foundations/constants/size'

type Props = {
  isDisabled: boolean
  isOpen: boolean
  onCancel: () => void
  onConfirm: () => void
}
export default function PortfolioConfirmRebalanceCashModal({
  isDisabled,
  isOpen,
  onCancel,
  onConfirm,
}: Props) {
  return (
    <Modal
      isCentered
      isOpen={isOpen}
      onClose={() => {
        onCancel()
      }}
      size="sm"
    >
      <ModalOverlay bg="rgba(0, 0, 0, 0.2)" />
      <ModalContent>
        <ModalHeader />
        <ModalCloseButton />
        <ModalBody paddingX={0}>
          <PDSFlexBox
            flexDirection="column"
            gap={SIZE.s16}
            paddingX={SIZE.s32}
            paddingBottom={SIZE.s16}
          >
            <PDSText
              fontWeight={FONT_WEIGHT.semibold}
              color={COLOR.textPrimary}
              size="lg"
            >
              Confirm investment of excess cash?
            </PDSText>
            <PDSText
              color={COLOR.textSecondary}
              fontWeight={FONT_WEIGHT.regular}
              variant="p"
            >
              To invest this portfolio's excess cash, Pave Pro will generate a
              new set of suggested trades If you have automation turned on, the
              trades will be placed automatically without requiring your
              approval.
            </PDSText>
            <PDSText
              color={COLOR.textSecondary}
              fontWeight={FONT_WEIGHT.regular}
              variant="p"
            >
              If you have automation turned off, the suggested trades will not
              be placed until you manually approve them.
            </PDSText>
            <PDSText
              color={COLOR.textSecondary}
              fontWeight={FONT_WEIGHT.regular}
              variant="p"
            >
              This action may trigger a wash sale as your last set of trades may
              have been placed within the last 30 days. Wash sales relate to
              realizing losses and trading the same security within a 30 day
              window. Wash sales will be listed on a brokerage statement and may
              be disclosed to the IRS. Please contact a tax adviser for
              guidance.
            </PDSText>
          </PDSFlexBox>
        </ModalBody>
        <PDSSeparator />
        <ModalFooter>
          <PDSFlexBox
            flexDirection="column"
            padding={SIZE.s32}
            gap={SIZE.s8}
            width="100%"
          >
            <PDSButton
              text="Continue"
              type="submit"
              onClick={onConfirm}
              disabled={isDisabled}
            />
            <PDSButton text="Cancel" variant="tertiary" onClick={onCancel} />
          </PDSFlexBox>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
